export default "__VITE_ASSET__DYXw58DK__";